/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import clsx from "clsx";
import { useState, useEffect, useRef, useCallback } from "react";
import MyProductgridList from "./MyProductgridList";
import { useDispatch, useSelector } from "react-redux";
import { getNewFilterdProducts } from "../../store/actions/product-actions";
import { useLocation } from "react-router-dom";
import { SET_FILTER } from "../../store/types";

const ShopProducts = ({ products, layout }) => {
  const observerRef = useRef(null);
  const endMessageRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const params = useLocation();
  const value = params?.search?.slice(1, 20);


  // Extract search parameters
  const queryParams = new URLSearchParams(params.search);
  const searchTerm = queryParams.get('search');
  const brandId = queryParams.get("brandId")
  const minPrice = queryParams.get("minPrice")
  const isBestSeller = queryParams.get('isBestSeller'); // "true"
  const Category = queryParams.get("category")
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showEndMessage, setShowEndMessage] = useState(false);
  const productsPerPage = 15;
  const dispatch = useDispatch();
  const [totalLimit, setTotalLimit] = useState(productsPerPage);
  const [hasMoreToFetch, setHasMoreToFetch] = useState(true);
  const TotalProductLength = useSelector(
    (state) => state?.products?.pagination?.totalProducts
  );
  const filter = useSelector(
    (state) => state.products.filter
  );

  useEffect(() => {
    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Only proceed if searchTerm has a value and length > 0
    if (searchTerm && searchTerm.trim().length > 0) {
      // Set a 2-second delay before executing the search
      searchTimeoutRef.current = setTimeout(() => {
        setIsLoading(true);
        dispatch(getNewFilterdProducts({
          page: 1,
          limit: 15,
          status: 1,
          isVisible: 1,
          name: searchTerm,
          usedType: "USED",
          sortBy: filter.sortBy || localStorage.getItem("sortBy"),
          sortOrder: filter.sortOrder || localStorage.getItem("sortOrder"),

        }))
          .then(() => {
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
          });
      }, 500); // 2 second delay
    }

    // Cleanup function to clear timeout on unmount or dependency change
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchTerm, dispatch]);

  useEffect(() => {

    if (brandId) {

      dispatch(getNewFilterdProducts({
        page: 1,
        limit: 15,
        status: 1,
        isVisible: 1,
        brands: filter?.brands || "",
        usedType: "USED",
        sortBy: "name" || "",
        sortOrder: "desc" || "",

      }))
    }
  }, [brandId, dispatch]);


  console.log("filter-->", filter.sortBy, filter.sortOrder)
  // useEffect(() => {

  //   if (minPrice) {

  //     dispatch(getNewFilterdProducts({
  //       page: 1,
  //       limit: 15,
  //       status: 1,
  //       isVisible: 1,
  //       minPrice: filter.minPrice,
  //       maxPrice: filter.maxPrice,
  //       usedType: "USED",
  //       sortBy: "price" || "",
  //       sortOrder: "desc" || ""
  //     }))
  //   }
  // }, [minPrice, dispatch]);

  useEffect(() => {

    if (isBestSeller) {

      dispatch(getNewFilterdProducts({
        page: 1,
        limit: 15,
        status: 1,
        isVisible: 1,
        isBestSeller: "true",
      }))
    }
  }, [isBestSeller, dispatch]);
  useEffect(() => {

    if (Category) {

      dispatch(getNewFilterdProducts({
        page: 1,
        limit: 15,
        status: 1,
        isVisible: 1,
        category: Category,
        usedType: "USED",
        sortOrder: "desc" || ""
      }))
    }
  }, [Category, dispatch]);
  // Load initial products
  useEffect(() => {
    if (products && products.length > 0) {
      setDisplayedProducts(products.slice(0, productsPerPage));
      setPage(1);
      setShowEndMessage(products.length <= productsPerPage);
      setHasMoreToFetch(true); // Reset this flag when products prop changes
    }
  }, [products]);

  const loadMoreProducts = useCallback(() => {
    if (isLoading || !products) return;

    setIsLoading(true);

    const nextPage = page + 1;
    const startIndex = (nextPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;

    // Check if we need to fetch more products from the API
    const shouldFetchMore = startIndex >= products.length && hasMoreToFetch;

    if (shouldFetchMore && TotalProductLength !== products.length && products.length > 1) {
      const newLimit = totalLimit + productsPerPage;
      setTotalLimit(newLimit);
      let usedType = "";

      if (value.includes("USED")) usedType = "USED";
      else if (value.includes("NEW")) usedType = "NEW";
      else if (value.includes("REFURBISHED")) usedType = "REFURBISHED";

      const payload = {
        page: 1,
        limit: newLimit,
        usedType,
        minPrice: filter.minPrice,
        maxPrice: filter.maxPrice,
        category: filter.category,
        modelId: filter.modelId,
        storage: filter.storage,
        ram: filter.ram,
        color: filter.color,
        name: searchTerm,
        sortBy: filter.sortBy || localStorage.getItem("sortBy"),
        sortOrder: filter.sortOrder || localStorage.getItem("sortOrder"),
      };

      // Only include `brands` if searchTerm is not present
      if (!searchTerm) {
        payload.brands = filter.brands;
      }
      dispatch(
        getNewFilterdProducts(payload)
      )
        .then((response) => {
          setIsLoading(false);
          setPage(nextPage);
          setDisplayedProducts(products);
          if (response && response.length <= products.length) {
            setHasMoreToFetch(false); // We've reached the end of available products
            setShowEndMessage(true);
          } else {
            setShowEndMessage(false);
          }
        })
        .catch(() => {
          setIsLoading(false);
          setShowEndMessage(true);
          setHasMoreToFetch(false);
        });
    } else {
      // We have more products locally that we can display
      const newProducts = products.slice(
        startIndex,
        Math.min(endIndex, products.length)
      );

      setDisplayedProducts((prev) => [...prev, ...newProducts]);
      setPage(nextPage);
      setIsLoading(false);
      setShowEndMessage(endIndex >= products.length && !hasMoreToFetch);
    }
  }, [
    isLoading,
    page,
    products,
    totalLimit,
    dispatch,
    productsPerPage,
    hasMoreToFetch,
  ]);

  // Setup IntersectionObserver to watch the end message
  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect();

    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isLoading) {
          loadMoreProducts();
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (endMessageRef.current) {
      observerRef.current.observe(endMessageRef.current);
    }

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [loadMoreProducts, isLoading]);

  const ProductSkeleton = () => (
    <div className="col-lg-3 col-md-6 col-sm-6 col-xs-6 mb-25">
      <div className="product-grid-item-skeleton">
        <div className="product-img-skeleton"></div>
        <div className="product-content-skeleton">
          <div className="title-skeleton"></div>
          <div className="price-skeleton"></div>
          <div className="rating-skeleton"></div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className="shop-bottom-area mt-35"
      style={{ minHeight: "80vh", overflowX: "hidden" }}
    >
      <div className={clsx("row", layout)}>
        <MyProductgridList products={products} spaceBottomClass="mb-25" />
        {isLoading &&
          Array.from({ length: 4 }).map((_, i) => <ProductSkeleton key={i} />)}
      </div>

      {/* Trigger element for loading more - always present but only visible at end */}
      <div
        ref={endMessageRef}
        className="text-center pb-4"
        style={{ minHeight: "20px" }}
      >
        {showEndMessage && !isLoading && (
          <p>You've reached the end of products</p>
        )}
      </div>

      {/* Loading indicator */}
      {isLoading && (
        <div
          className="text-center py-4"
          style={{ width: "100%", position: "relative" }}
        >
          <div
            className="loading-indicator"
            style={{
              display: "inline-block",
              padding: "10px 20px",
              borderRadius: "4px",
              backgroundColor: "rgba(0,0,0,0.05)",
            }}
          >
            <p style={{ margin: 0 }}>Loading more products...</p>
          </div>
        </div>
      )}
    </div>
  );
};

ShopProducts.propTypes = {
  layout: PropTypes.string,
  products: PropTypes.array,
};

export default ShopProducts;
